import { createRequest, handleErrorCatchLog } from '../Helpers/GenericHelpers'
import { AuthRequest } from '../Interfaces/AuthRequest'
import { AuthResponse } from '../Interfaces/AuthResponse'

/**
 * Send a fake token request, always return a valid token
 */
const requestToken = async (config: string, authenticateRequest: AuthRequest): Promise<AuthResponse> => {
  const url = `/api/login/?config=${config}`
  try {
    const response = await createRequest(url, 'POST', authenticateRequest, '', true, true)
    return await response.json()
  } catch (err) {
    handleErrorCatchLog(err, 'Error on requestToken')
  }
}

export default requestToken
